import { AnalyticsUserData } from '@mb/lib/analytics';

import { getAnalyticsUserData } from '../../../entities/customer';
import { SignInCustomerData } from '../../../modules/auth';

export interface SignInAnalyticsEventParams {
  user: Partial<AnalyticsUserData>;
}

export const sendSignInAnalyticsEvent = (
  params: SignInAnalyticsEventParams,
) => {
  const { user } = params;

  mitGTM.sendEvent({
    event: 'login',
    non_interaction_flag: false,
    user: getAnalyticsUserData(user),
  });
};

export const getSignInAnalyticsUserData = (
  customerData: Partial<SignInCustomerData> = {},
): AnalyticsUserData => {
  return getAnalyticsUserData({
    sign_in_state: true,
    user_id: customerData.id?.toString(),
    email_hash: customerData.email_sha256,
    group: customerData.group_id?.toString(),
    type: customerData.job_type_label || null,
    primary_specialization: customerData.area_spec_label || null,
    company: customerData.university_school_name || customerData.company_name,
    test_user: !!Number(customerData.test_user) ? 'yes' : 'no',
    internal: mitGTM.isInternalUser(customerData.email || ''),
  });
};
